export { default as ListView } from 'notifications_historic/components/NotificationsHistoricListView';
export { default as FormView } from 'notifications_historic/components/NotificationHistoricFormView';
export { default as Row } from 'notifications_historic/components/list/NotificationsHistoricListRow';



// WEBPACK FOOTER //
// src/modules/secured/modules/notifications_historic/components/index.js